import { MicNoneSharp } from "@material-ui/icons";
import { cleanText } from "modules/app/utils";
import { messageType } from "modules/app/utils/models/message";
import React from "react";
import { useTranslation } from "react-i18next";

import { Container } from "./styles";

function RepliedMessage({ message, customer, ...props }) {
  const { t } = useTranslation(["Contacts", "Customer"]);

  function showMessage(message) {
    const type = messageType(message);

    if (["audio", "image", "video", "file"].includes(type)) {
      return t(`messages.type.${type}`);
    } else if (Boolean(message?.body)) {
      return cleanText(message.body);
    } else {
      return t("messages.resume.first_contact");
    }
  }

  return (
    <Container className="replied-message" {...props}>
      <div>
        <p>{message.from == "user" ? "Você" : customer.name}</p>

        {!message.attachment_content_type && (
          <span>{showMessage(message)}</span>
        )}

        {message.attachment_content_type?.includes("audio") && (
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MicNoneSharp /> áudio
          </span>
        )}

        {message.attachment_content_type?.includes("video") && "vídeo"}

        {message.attachment_content_type?.includes("image") && "imagem"}
      </div>

      {message.attachment_content_type?.includes("image") && (
        <div className="preview">
          <img src={message.attachment_url} />
        </div>
      )}
    </Container>
  );
}

export default RepliedMessage;
